import { createBrowserRouter, Link } from "react-router-dom";
import RichMenu from "./components/icons/RichMenu"
import Register from "./pages/register/register";
import MySchedule from "./pages/mySchedule/mySchedule";

import EditProfile from "./pages/profile/editProfile";
import AuthProfile from "./pages/profile/authprofile";
import Profile from "./pages/profile/profile";
import About from "./pages/about/about";
import RenewMember from "./pages/renewMember/renewMember";
import RenewMemberSuccess from "./pages/renewMember/renewMemberSuccess";
import AuthSchedule from "./pages/schedule/authschedule";
import Schedule from "./pages/schedule/schedule";
import ScheduleStep2 from "./pages/schedule/step2";
import ScheduleStep3 from "./pages/schedule/step3";
import ScheduleStep4 from "./pages/schedule/step4";

import DevTest1 from "./pages/dev/test1";
import DevTest2 from "./pages/dev/test2";
import AuthCollectPoint from "./pages/collectPoint/authcollectPoint";
import CollectPoint from "./pages/collectPoint/collectPoint";
import PointEvidence from "./pages/collectPoint/pointEvidence";
import PointHistory from "./pages/collectPoint/pointHistory";

import WorkAgreement from "./pages/workAgreement/workAgreement";
import CashWork from "./pages/cashWork/cashWork";
import CashWorkView from "./pages/cashWork/cashWorkView";
import AuthCheckIn from "./pages/checkIn/authcheckIn";
import CheckIn from "./pages/checkIn/checkIn";
import HistoryCheckIn from "./pages/checkIn/HistoryCheckIn";

// iframe
import RewardUpload from "./pages/iframe/RewardUpload";
import WorkShiftScheduleUpload from "./pages/iframe/WorkShiftScheduleUpload";


const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <div>
        <h1>Link</h1>
        <ul>
          <li>
            <Link to="about">About Us</Link>
          </li>
          <li>
            <Link to="register">Register</Link>
          </li>
          <li>
            <Link to="authprofile">Auth Profile</Link>
          </li>
          <li>
            <Link to="profile">Profile</Link>
          </li>
          <li>
            <Link to="schedule">Schedule</Link>
          </li>
          <li>
            <Link to="mySchedule">MySchedule</Link>
          </li>
          <li>
            <Link to="editProfile">EditProfile</Link>
          </li>
          <li>
            <Link to="devTest1">Dev Test Redux 1</Link>
          </li>
          <li>
            <Link to="devTest2">Dev Test Redux 2</Link>
          </li>
          <li>
            <Link to="work-agreement">ข้อตกลงการทำงาน</Link>
          </li>
          <li>
            <Link to="check-in">checkIn</Link>
          </li>
          <li>
            <Link to="history-check-in">HistoryCheckIn</Link>
          </li>
          <li>
            <Link to="cash-work">CashWork</Link>
          </li>
          <li>
            <Link to="collect-point">Collect-point</Link>
          </li>
        </ul>
        <div className="rich-menu">
          <div className="rich-menu-box">
            <RichMenu/>
            <ul>
              <Link to="authprofile">
                <li>ข้อมูลสมาชิก</li>
              </Link>
              <Link to="cash-work">
                <li>งานเงินสด</li>
              </Link>
              <Link to="authcheck-in">
                <li>บันทึกเข้า - ออก</li>
              </Link>
              <Link to="authschedule">
                <li>ตารางเวร</li>
              </Link>
              <Link to="authcollect-point">
                <li>แต้มสะสมบุญ</li>
              </Link>
              <Link to="work-agreement">
                <li>ข้อตกลงการทำงาน</li>
              </Link>
            </ul>
            </div>
        </div>
      </div>
    ),
  },
  {
    path: "about",
    element: <About />,
  },
  {
    path: "register",
    element: <Register />,
  },
  {
    path: "mySchedule",
    element: <MySchedule />,
  },
  {
    path: "authprofile",
    element: <AuthProfile />,
  },
  {
    path: "profile",
    element: <Profile />,
  },
  {
    path: "editProfile",
    element: <EditProfile />,
  },
  {
    path: "renew-member",
    element: <RenewMember />,
  },
  {
    path: "renew-member-success",
    element: <RenewMemberSuccess />,
  },
  {
    path: "authschedule",
    element: <AuthSchedule />,
  },
  {
    path: "schedule",
    element: <Schedule />,
  },
  {
    path: "schedule-step2",
    element: <ScheduleStep2 />,
  },
  {
    path: "schedule-step3",
    element: <ScheduleStep3 />,
  },
  {
    path: "schedule-step4",
    element: <ScheduleStep4 />,
  },
  {
    path: "work-agreement",
    element: <WorkAgreement />,
  },
  {
    path: "cash-work",
    element: <CashWork />,
  },
  {
    path: "cash-work-view",
    element: <CashWorkView />,
  },
  {
    path: "authcheck-in",
    element: <AuthCheckIn />,
  },
  {
    path: "check-in",
    element: <CheckIn />,
  },
  {
    path: "history-check-in",
    element: <HistoryCheckIn />,
  },

  {
    path: "devTest1",
    element: <DevTest1 />,
  },
  {
    path: "devTest2",
    element: <DevTest2 />,
  },
  {
    path: "authcollect-point",
    element: <AuthCollectPoint />,
  },
  {
    path: "collect-point",
    element: <CollectPoint />,
  },
  {
    path: "point-evidence",
    element: <PointEvidence />,
  },
  {
    path: "point-history",
    element: <PointHistory />,
  },
  {
    path: "reward-upload",
    element: <RewardUpload />,
  },
  {
    path: "work-shift-schedule-upload",
    element: <WorkShiftScheduleUpload />,
  },
]);
export default router;
